import { initialState, playgroundReducer } from './playground-reducer';
export const createPlaygroundStoreInitializer = () => (set) => ({
    state: initialState,
    dispatch: (args) => set((state) => (Object.assign(Object.assign({}, state), { state: playgroundReducer(state.state, args) }))),
});
//# sourceMappingURL=playground-store.initializer.js.map